<template>
    <section v-if="activityItem.text && activityItem.icon" class="ut-flex ut-py-3 ut-border-b">
      <figure v-if="activityItem.icon" class="ut-w-10 ut-flex-shrink-0 ut-text-teal-300">
        <svg-loader
          :name="activityItem.icon"
          :color-class="'ut-text-teal-300'"
          :width="15"
          :height="15"
          class="timeline-icon ut-circle-img" />
      </figure>
      <div class="ut-w-full">
        <h3 class="">{{ activityItem.text }}</h3>
        <p v-if="activityItem.note" class="ut-text-sm">{{ activityItem.note }}</p>
        <p class="ut-text-neutral-200">{{ date }}</p>

        <div class="more-info" :id="`oamatch_moreinfo_${this.$vnode.key}`" v-if="isOAMatch()">
          <div class="ut-text-xs ut-mr-0 ut-my-2 ut-text-green-300 ut-cursor-pointer" v-gaEvent="{ category: gacategory, action: oamatch_info_gaaction }" @click="toggleOAMatchInfo()"><u>More information about this type of prospect</u></div>
          <p class="ut-text-neutral-200" v-if="showOAMatchInfo">{{ oaMatchInfo }}</p>
        </div>
      </div>
      <figure class="ut-w-10 ut-flex-shrink-0">
        <svg-loader v-if="data.avatarImageUrl === 'oaConsultant'"
          name="icon-shield"
          :color-class="'ut-text-green-400'"
          :width="16"
          :height="16"
          class="ut-ml-2" />
        <avatar v-else-if="data.avatarImageUrl"
              class="agent-avatar-sm ut-ml-2"
              :size="'sm'"
              :imgSrc="avatarImage" />
      </figure>
    </section>
</template>

<script>
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';
import Avatar from '@/components/Avatar.vue';
import ProspectActivityType from '@/Mapper/ProspectActivityType';
import {
  ProspectActivityActionTypeId,
  ProspectPropertyRelationshipId,
  ProspectSellingTimeframeId,
  ProspectReminderTypeId,
  OaLeadSourceTypeId,
} from '@/Mapper/ProspectActivityActionType';
import ProspectStageType from '@/Mapper/ProspectStageType';
import ProspectStatusType from '@/Mapper/ProspectStatusType';
import ProspectingHelpers from '@/helpers/prospecting-helpers';

export default {
  name: 'ProspectActivityItem',
  components: {
    SvgLoader,
    Avatar,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
    date: {
      type: String,
      required: false,
    },
    type: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      oamatch_info_gaaction: 'Prospect Profile - more information OA Match expand info',
      oaMatchInfo: 'We’ve identified this opportunity based on the vendors browsing behaviour online on OpenAgent. This vendor also exists in your CRM. We cannot pass over any information you do not already have in your CRM (like an address) however, we can tell you they’re researching property online and that they own a property in a suburb you have sales in. Our data shows these vendors have a high likelihood of listing within the next 6 months.',
      showOAMatchInfo: false,
    };
  },
  computed: {
    avatarImage() {
      if (this.data.avatarImageUrl === 'oaConsultant') {
        // eslint-disable-next-line global-require
        return 'oaConsultant';
      }
      return this.data.avatarImageUrl;
    },
    activityItem() {
      let data = {
        text: null,
        note: null,
        icon: null,
      };

      switch (this.type) {
        case ProspectActivityType.contact:
          data = this.getActivityData();
          break;
        case ProspectActivityType.prospect:
          data = this.getActivityData();
          break;
        case ProspectActivityType.stageChange:
          data = this.getStageChangeData();
          break;
        case ProspectActivityType.statusChange:
          data = this.getStatusChangeData();
          break;
        case ProspectActivityType.reminder:
          data = this.getReminderData();
          break;
        case ProspectActivityType.note:
          data.text = this.data.note;
          data.icon = 'icon-note';
          break;
        default:
          break;
      }
      return data;
    },
  },
  created() {
  },
  methods: {
    getActivityData() {
      let data = {
        text: null,
        note: null,
        icon: null,
      };

      switch (this.data.actionType.activityActionTypeId) {
        case ProspectActivityActionTypeId.requestedAppraisal:
          data.text = `Requested an appraisal from you for ${this.$options.filters.address(this.data.contactPropertyAddress)}`;
          data.icon = 'icon-appraisal';
          break;
        case ProspectActivityActionTypeId.propertyEstimate:
          // IF: Owner || ownerInvestor
          if (this.data.metaData.propertyRelationship.propertyRelationshipId
                === ProspectPropertyRelationshipId.ownerOccupier
              || this.data.metaData.propertyRelationship.propertyRelationshipId
                === ProspectPropertyRelationshipId.ownerInvestor) {
            data.text = `${this.data.metaData.propertyValuation.show ? `Received an estimate for
              ${this.$options.filters.address(this.data.contactPropertyAddress)} for
              $${this.$helpers.priceFormat(this.data.metaData.propertyValuation.low)} -
              $${this.$helpers.priceFormat(this.data.metaData.propertyValuation.high)} via online estimate tool`
              : `Tried to receive an estimate for
              ${this.$options.filters.address(this.data.contactPropertyAddress)}
              via online estimate tool, but not enough data was available.`}`;
            data.icon = 'icon-linechart';
          }
          break;
        case ProspectActivityActionTypeId.oaMatch:

          // SmartSearch or PowerBy
          data.text = `Discovered an opportunity with ${this.contact.firstName} -  Researching agents and could be selling soon`;

          if (this.data.rawMetaData.lead.leadSourceTypeId
          === OaLeadSourceTypeId.propertyReports) {
            data.text = `Discovered an opportunity with ${this.contact.firstName} - Received property report and could be selling soon`;
          }

          if (this.data.rawMetaData.lead.leadSourceTypeId
          === OaLeadSourceTypeId.openEstimates) {
            data.text = `Discovered an opportunity with ${this.contact.firstName} - Received property estimate and could be selling soon`;
          }

          data.icon = 'icon-lightbolt';
          break;
        case ProspectActivityActionTypeId.prospectCreated:
          data.text = 'Added to your CRM ';
          data.icon = 'icon-user';

          if (this.contact.contactTypes.length > 0) {
            let contactTypes = 'Categories - ';

            for (let i = 0; i < this.contact.contactTypes.length; i++) {
              const ct = this.contact.contactTypes[i];

              contactTypes += ct.type;

              if ((this.contact.contactTypes.length - 1) !== i) {
                contactTypes += ', ';
              }
            }

            data.note = contactTypes;
          }

          break;
        case ProspectActivityActionTypeId.timeframeAndRelationship:
          // IF: Owner || ownerInvestor
          if (this.data.metaData.propertyRelationship.propertyRelationshipId
                === ProspectPropertyRelationshipId.ownerOccupier
              || this.data.metaData.propertyRelationship.propertyRelationshipId
                 === ProspectPropertyRelationshipId.ownerInvestor) {
            // Check Selling Timeframe
            if (this.data.metaData.sellingTimeframe.sellingTimeframeId // Selling within 3 months
                 === ProspectSellingTimeframeId.within3Months) {
              data.text = `Said they are the owner of ${this.$options.filters.address(this.data.contactPropertyAddress)}
              and selling ${this.data.metaData.sellingTimeframe.type.toLowerCase()}`;
            } else if (this.data.metaData.sellingTimeframe.sellingTimeframeId // Not Selling
                 === ProspectSellingTimeframeId.notSelling) {
              data.text = `Said they are the owner of ${this.$options.filters.address(this.data.contactPropertyAddress)}`;
            } else { // Selling in x months
              data.text = `Said they are the owner of ${this.$options.filters.address(this.data.contactPropertyAddress)}
              and selling in ${this.data.metaData.sellingTimeframe.type.toLowerCase()}`;
            }
          }
          data.icon = 'icon-house';
          break;
        case ProspectActivityActionTypeId.sent:
          // Contact or Prospect
          if (this.data.receiverActorType.activityActorTypeId === 1
            || this.data.receiverActorType.activityActorTypeId === 2) {
            data = this.getEmailSmsData();
          }
          break;
        default:
          break;
      }

      if (ProspectingHelpers.isOaAssistantActivity(this.data)) {
        const appraisalInfo = this.data.rawMetaData.appraisalRequested
          ? this.data.rawMetaData.appraisalRequested : null;

        data.text = `Your OpenAgent Assistant verified this seller${appraisalInfo ? ` - ${appraisalInfo}` : ''}`;
        data.icon = 'icon-phone';
        data.note = this.data.rawMetaData.futurePlan ? this.data.rawMetaData.futurePlan : null;
      }

      return data;
    },
    getStageChangeData() {
      const data = {
        text: null,
        note: null,
        icon: null,
      };

      switch (this.data.stageType.stageTypeId) {
        case ProspectStageType.contacted:
          data.text = 'Contacted successfully';
          data.icon = 'icon-check';
          break;
        case ProspectStageType.appraised:
          data.text = `Appraised the property on ${this.$helpers.convertFromUTC(this.date, 'D MMM, YYYY')}`;
          data.icon = 'icon-appraisal';
          break;
        case ProspectStageType.listed:
          data.text = `Listed the property on ${this.$helpers.convertFromUTC(this.date, 'D MMM, YYYY')}`;
          data.icon = 'icon-listing';
          break;
        case ProspectStageType.sold:
          data.text = `Sold property on ${this.$helpers.convertFromUTC(this.date, 'D MMM, YYYY')}`;
          data.icon = 'icon-listing';
          break;
        case ProspectStageType.attempted:
          data.text = 'Tried calling';
          data.icon = 'icon-phone';
          break;
        default:
          break;
      }
      return data;
    },
    getStatusChangeData() {
      const data = {
        text: null,
        note: null,
        icon: null,
      };

      switch (this.data.statusTypeId) {
        case ProspectStatusType.removed:
          data.text = 'Removed prospect';
          data.icon = 'icon-open-close';
          break;
        default:
          break;
      }
      return data;
    },
    getReminderData() {
      const data = {
        text: null,
        note: null,
        icon: null,
      };

      switch (this.data.reminderType.reminderTypeId) {
        case ProspectReminderTypeId.followUp:

          if (this.data.completedDate) {
            data.text = `Successfully followed up on ${this.$helpers.convertFromUTC(this.data.completedDate, 'D MMM, YYYY')}`;
            data.icon = 'icon-check';
          } else {
            data.text = `Booked a follow-up call for ${this.$helpers.convertFromUTC(this.data.reminderDate, 'D MMM, YYYY')}`;
            data.icon = 'icon-calendar';
          }

          data.note = this.data.description;

          break;
        case ProspectReminderTypeId.bookedAppraisal:
          data.text = `Booked an appraisal for ${this.$helpers.convertFromUTC(this.data.reminderDate, 'D MMM, YYYY')}`;
          data.note = this.data.description;
          data.icon = 'icon-calendar';
          break;
        default:
          break;
      }
      return data;
    },
    getEmailSmsData() {
      const data = {
        text: null,
        note: null,
        icon: 'icon-post',
      };

      switch (this.data.name) {
        case 'PLITE_SMS_TO_CONTACT':
          data.text = 'Received SMS - What’s your property worth?';
          break;
        case 'CONTACT-PROPERTY-AVM-EMAIL':

          // eslint-disable-next-line no-case-declarations
          const address = this.data.rawMetaData.address.fullAddress
            ? ` for ${this.data.rawMetaData.address.fullAddress}` : '';

          data.text = `Received email - Quarterly property value update${address}`;
          break;
        case 'CONTACT-SUBURB-STATS-EMAIL':

          // eslint-disable-next-line no-case-declarations
          const suburb = this.data.rawMetaData.suburb.suburb
            ? this.data.rawMetaData.suburb.suburb : this.data.rawMetaData.suburb;

          data.text = `Received email -${suburb ? ` ${suburb}` : ''} monthly market update`;
          break;
        default:
          break;
      }

      return data;
    },
    isOAMatch() {
      if (this.$route.query.moreinfo) {
        this.showOAMatchInfo = true;
      }

      return this.data.actionType && this.data.actionType.activityActionTypeId == ProspectActivityActionTypeId.oaMatch;
    },
    toggleOAMatchInfo() {
      this.showOAMatchInfo = !this.showOAMatchInfo;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
   .timeline-icon {
    @apply ut-inline-flex bg-opacity ut-align-middle;
    height: 28px;
    width: 28px;
  }

  h3, .sub-text {
    font-size: 13px;
    line-height: 20px;
  }

  p {
    font-size: 11px;
    line-height: 20px;
  }
  svg {
    height: 15px;
    width:15px;
  }

  section {
   border-color: #979797;
   border-color: rgba(#979797, 0.2);
  }

  .bg-opacity {
    background: #28AFC6; /* The Fallback */
   background: rgba(#28AFC6, 0.2);
  }

  :last-child {
      @apply ut-border-none ut-pb-0;
    }

  :first-child {
      @apply ut-pt-0;
  }
</style>
